var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMusicIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.265,
    height: 15.94,
    viewBox: "0 0 12.265 15.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "fill-current",
    id: "Icon_ionic-ios-musical-notes",
    "data-name": "Icon ionic-ios-musical-notes",
    d: "M18.64,3.383l-7.9,1.533a.34.34,0,0,0-.31.307v9.2a1.057,1.057,0,0,1-.092.448,1.021,1.021,0,0,1-.617.487c-.126.042-.3.08-.5.126-.923.207-2.468.559-2.468,1.985a1.754,1.754,0,0,0,1.6,1.82,1.869,1.869,0,0,0,.272.027h0a4.73,4.73,0,0,0,1.962-.506,2.064,2.064,0,0,0,.923-1.832V8.835a.3.3,0,0,1,.245-.3L17.575,7.36a.306.306,0,0,1,.368.3v5.016a1.1,1.1,0,0,1-.1.513,1.018,1.018,0,0,1-.621.487c-.126.042-.337.08-.54.126-.923.207-2.468.556-2.468,1.981a1.757,1.757,0,0,0,1.6,1.851,3.167,3.167,0,0,0,.743-.034,4.393,4.393,0,0,0,1.4-.5,2.02,2.02,0,0,0,1.054-1.847V3.678A.3.3,0,0,0,18.64,3.383Z",
    transform: "translate(-6.75 -3.375)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicIcon);
export default __webpack_public_path__ + "static/media/music-icon.453478d76181d3498210bd8785f175d3.svg";
export { ForwardRef as ReactComponent };